import { useQuery } from '@tanstack/react-query';
import { getOptionGroupById } from '../../api/apiOptionGroups';
import i18next from 'i18next';

/**
 * Hook to fetch a single option group by ID
 */
export const useGetOptionGroupById = (id) => {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ['optionGroup', id, i18next.language],
        queryFn: () => getOptionGroupById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        optionGroup: data?.data?.data || null,
        error,
        isLoading,
        refetch
    };
};
